import React from 'react';
import { Mail, KeyRound, UserRound, LockKeyhole } from 'lucide-react';
import { useAuth } from '../../auth';
import { AccountBrandMark } from './AccountBrandMark';
import { AccountDetailField } from './AccountDetailField';
import { PasswordSettings } from './PasswordSettings';
import { AccountProviderHandles } from './AccountProviderHandles';
import './accountPanels.css';

export const AccountDetails = () => {
  const { user } = useAuth();
  return <div className="settings-account-panels" data-testid="settings-account-panels">
    <section className="settings-section settings-account-panel" data-testid="settings-account-details-section" aria-labelledby="settings-account-details-heading">
    <div className="settings-panel-heading">
      <span className="settings-panel-icon"><UserRound size={22} aria-hidden="true" data-testid="settings-account-details-icon" /></span>
      <div><h2 id="settings-account-details-heading" data-testid="settings-account-details-title">Account details</h2><p data-testid="settings-account-details-description">Manage your account information and connected platforms.</p></div>
    </div>
    <div className="settings-account-fields" data-testid="settings-account-fields">
      <AccountDetailField icon={Mail} label="Email address" description="Your GVRewards account email address" fullWidth inputId="settings-email" testId="settings-email-section" labelTestId="settings-email-label" value={user.email} disabled />
      <AccountDetailField icon={AccountBrandMark} label="GVRewards username" inputId="settings-gvrewards-username" testId="settings-gvrewards-username-field" labelTestId="settings-gvrewards-username-label" value={user.username} disabled />
      <AccountProviderHandles key={user.id} />
    </div>
    <p className="settings-account-privacy" data-testid="settings-account-privacy"><LockKeyhole size={18} aria-hidden="true" />Your account details are private.</p>
    </section>
    <section id="settings-password-section" className="settings-section settings-account-panel settings-account-password" data-testid="settings-password-section" aria-labelledby="settings-password-heading">
      <div className="settings-panel-heading">
        <span className="settings-panel-icon settings-password-heading-icon"><KeyRound size={32} strokeWidth={2} aria-hidden="true" data-testid="settings-password-heading-key" /></span>
        <div><h2 id="settings-password-heading" data-testid="settings-password-title">Password</h2><p data-testid="settings-password-description">Keep your account secure with a strong password.</p></div>
      </div>
      <PasswordSettings />
    </section>
  </div>;
};